import { createContext } from 'react';

/** @type {undefined | import('react').Context<UserStore>} */
const UserStoreContext = createContext();

export default UserStoreContext;
